import { render } from "./AboutUs.vue?vue&type=template&id=41225273"
import script from "../js/about-us.js?vue&type=script&lang=js&external"
export * from "../js/about-us.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__